
import HeaderNav from '@/components/header-nav'
import XyFooter from '@/views/components/xy-footer/index.vue'
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  reactive,
  Ref,
  toRefs,
  watchEffect,
  defineAsyncComponent
} from 'vue'
import { RouteRecordRaw } from 'vue-router'
import router from '@/router'
import { useStore } from '@/store'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { LogoutInfoType } from '@/types/user'
import { ElMessage } from 'element-plus/lib/components'
import { getToken } from '@/utils/cookies'
import avatar from '@/assets/img/avatar.png'

interface State {
  routes: Ref<RouteRecordRaw[]>
  isLogin: Ref<boolean>
  showLoginDialog: Ref<boolean>
  avatarUrl: Ref<string>
  nickname: Ref<string>
  handleShowLogin: () => void
  handleCloseLogin: () => void
  logout: () => void
  imgError: () => void
}
export default defineComponent({
  components: {
    HeaderNav,
    XyFooter,
    Login: defineAsyncComponent(() => import('./views/components/login/index.vue'))
  },
  setup(): State {
    const store = useStore()

    const routes = computed(() => {
      return router.options.routes
    })
    const state = reactive({
      avatarUrl: store.state.user.userInfo.portrait
    })

    const showLoginDialog = computed(() => {
      return store.state.user.showLoginDialog
    })

    const isLogin = computed(() => {
      return store.state.user.user.isLogin
    })

    watchEffect(() => {
      state.avatarUrl = store.state.user.userInfo.portrait
    })

    const nickname = computed(() => {
      return store.state.user.userInfo.nickname
    })

    const token = computed(() => {
      return getToken()
    })

    onMounted(() => {
      document.addEventListener('contextmenu', _injectDisabledContextMenu, false)
      if (token.value) {
        store.dispatch(UserActionTypes.ACTION_UPDATE_LOCAL_USER, undefined)
      }
    })

    const _injectDisabledContextMenu = (event: MouseEvent) => {
      // 取消右键点击事件的默认行为
      event.preventDefault()
      event.stopPropagation()
    }

    const imgError = () => {
      state.avatarUrl = avatar
    }

    const handleShowLogin = () => {
      store.commit(UserMutationTypes.SET_SHOW_LOGIN_DIALOG, true)
    }

    const handleCloseLogin = () => {
      store.commit(UserMutationTypes.SET_SHOW_LOGIN_DIALOG, false)
    }

    function logout() {
      const logoutInfo: LogoutInfoType = {
        token: store.state.user.user.token,
        userId: store.state.user.user.userId,
        pf: 4,
        version: 'web'
      }
      store
        .dispatch(UserActionTypes.ACTION_LOGOUT, logoutInfo)
        .then((res: any) => {
          console.log(res)
          ElMessage.success('退出成功')
        })
    }

    onBeforeUnmount(() => {
      document.removeEventListener('contextmenu', _injectDisabledContextMenu)
    })

    return {
      routes,
      isLogin,
      showLoginDialog,
      nickname,
      ...toRefs(state),
      handleShowLogin,
      handleCloseLogin,
      logout,
      imgError
    }
  }
})
